import React from 'react';
import CalendarProvider from '../CalendarProvider';
import DayMapProvider from '../DayMapProvider';
import CalendarRoot from '../CalendarRoot';
/** @public */
function Calendar({
  className,
  dayMap,
  renderDayFn,
  ...props
}) {
  return React.createElement(CalendarProvider, {
    ...props
  }, React.createElement(DayMapProvider, {
    dayMap: dayMap,
    renderDayFn: renderDayFn
  }, React.createElement(CalendarRoot, {
    className: className
  })));
}
export default Calendar;